import type { ExternalTableSchema } from '@packages/table-builder';

export const tradeOrderDashboardTable: ExternalTableSchema = {
  metadata: {
    title: 'Trade Order Dashboard',
    entity: 'TradeOrderDashboard',
  },

  dataSource: {
    endpoint: '/api/award-settlement/api/v2/trade-order/placed-order-dashboard',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
      hasMoreItems: 'hasMoreItems',
    },
    requestParams: {
      OrderStatusId: 'filters.orderStatusId',
      CancelStatusId: 'filters.cancelStatusId',
      CompanyIds: 'filters.companyIds',
      MaxResultCount: 'table.pageSize',
      Sorting: 'table.sorting',
    },
    continuationCursor: {
      queryKey: 'DateTime',
      fieldPath: 'createdDate',
      format: 'iso',
    },
    filters: [
      {
        name: 'companyIds',
        placeholder: 'Company',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/app/participant-broker-account/company-list',
          labelField: 'companyName',
          valueField: 'id',
        },
      },
      {
        name: 'orderStatusId',
        placeholder: 'Order Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award-settlement/api/app/trade-order/trade-order-status',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    { field: 'createdDate', header: 'Date', type: 'date', sortable: false, width: 140, align: 'center' },
    { field: 'companyName', header: 'Company', sortable: false, width: 120 },
    { field: 'ticker', header: 'Ticker', sortable: true, width: 150, align: 'center' },
    {
      field: 'orderStatus',
      header: 'Order Status',
      type: 'badge',
      sortable: true,
      width: 200,
      align: 'center',
      badge: {
        statusMap: {
          Executed: 'success',
          Placed: 'success',
          Pending: 'info',
          Cancelled: 'error',
          'Partially Filled': 'pink',
          Received: 'success',
          Reversed: 'primary',
        },
        defaultVariant: 'info',
      },
    },
    { field: 'order', header: 'Order', sortable: true, width: 200, align: 'center' },
    { field: 'maxShares', header: 'Max Shares', type: 'number', sortable: true, width: 150, align: 'center' },
  ],

  actions: {
    row: [{ id: 'VIEW_DETAILS_TRADE_ORDER', label: 'View Details' }],
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'infiniteScroll', defaultSize: 25 },
    filterGrid: { columns: 2 },
    groupBy: {
      fields: ['createdDate'],
      expandMode: 'expanded',
      hideGroupedColumn: false,
      groupHeader: { showCount: true },
    },
  },
};
